import Axios from 'axios'

// Add header to distinguish ajax and non-ajax calls on server side
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

